import Base from './base'
import Dispatcher from './dispatcher'

const TIMEOUT_VALUE = 2000 // 2 seconds

export default (() =>
  class Taboola extends Base {
    constructor(elem, options) {
      super(elem, options)
      this.name = 'Taboola'
      this.initialized = false
      this.fallbackClass = Dispatcher
    }

    get isRendered() {
      return this.benjiPlacement?.isRendered || this.fallbackRendered
    }

    async renderNatively() {
      if (!this.elem.isConnected || this.isRendered || this.initialized) return
      this.benjiPlacement = await this._getPlacement()
      this.benjiPlacement.setOnEmptyCallback(this.renderFallback.bind(this))
      this.benjiPlacement.create()
      this.initialized = true
    }

    async _render() {
      if (this.isRendered) return Promise.resolve()
      return this.renderNatively().catch(e => this.renderFallback())
    }

    async onIsCurrentSlide() {
      return this._render()
    }

    async onIsNextSlide() {
      return this._render()
    }

    async _getPlacement() {
      return new Promise(resolve => {
        if (window.Taboola?.createPlacement) {
          const placement = window.Taboola?.createPlacement(this.elem)
          return resolve(placement)
        }

        const createPlacementPromise = new Promise((pass, err) => {
          document.addEventListener('Taboola:inited', () => {
            if (window.Taboola?.createPlacement) {
              const placement = window.Taboola?.createPlacement(this.elem)
              return pass(placement)
            }
            return err(new Error('[Taboola] interface error'))
          })
        })

        let id
        const timeoutPromise = new Promise((_, err) => {
          id = setTimeout(() => {
            clearTimeout(id)
            return err(new Error('[Taboola] timeout'))
          }, TIMEOUT_VALUE)
        })

        return resolve(Promise.race([createPlacementPromise, timeoutPromise]))
      })
    }

    _unsetActiveClasses() {
      this.elem.classList.remove('dl-taboola')
      this.elem.style.display = 'unset'
      // STATUS code 3 is for empty Ad
      if (
        this.benjiPlacement?.status === 3 &&
        this.elem.classList.contains('trc_related_container')
      ) {
        this.elem.classList.remove('trc_related_container')
      }
    }

    _setActiveClasses() {
      this.elem.parentNode?.setAttribute('data-type', 'taboola:placeholder')
      this.elem.parentNode?.classList.add('dl__slide--ad')
      this.elem.classList.add('dl-taboola')
    }
  })()
